<ion-header>
	<ion-toolbar>
		<ion-title>Save Sheet As New Template...</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="close()" color="primary">
				<ion-icon slot="icon-only" name="close-sharp"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>
<div class="container">
	<div class="scroll-vertical app-padding">
		<div class="form-section">
			<div class="form-group">
				<app-item class="rounded-border-box">
					<app-item-label>Template name</app-item-label>
					<app-item-input placeholder="enter..." [maxlength]="200" (valueChange)="nameChanged($event)"></app-item-input>
				</app-item>
			</div>
		</div>
	</div>
	<div class="footer-box app-padding">
		<app-button fill="solid" (click)="saveTemplate()">Save</app-button>
	</div>
</div>